!function(a){a.fn.simpleAlert=function(e){void 0===e&&(e={});return e=a.extend({title:"Alert",message:"",btnLabel:"OK"},e),this.each(function(){var s,l=a(this);l.addClass("simple-dialog active"),s='<div class="simple-dialog-content">',s+='<div class="simple-dialog-header"><h3 class="title">'+e.title+'</h3><a class="simple-dialog-close" data-action="close"></a></div>',s+='<div class="simple-dialog-body"><p class="message">'+e.message+"</p></div>",s+='<div class="simple-dialog-footer"><a class="simple-dialog-button" data-action="close">'+e.btnLabel+"</a></div>",s+="</div>",l.html(s),a(document).on("click",'a[data-action="close"]',function(e){e.preventDefault(),a(this).parents(".simple-dialog").removeClass("active")})}),this},a.fn.simpleConfirm=function(e){void 0===e&&(e={});return e=a.extend({title:"Confirm",message:"",acceptBtnLabel:"Accept",cancelBtnLabel:"Cancel",success:function(){},cancel:function(){}},e),this.each(function(){var s,l=a(this);l.addClass("simple-dialog active"),s='<div class="simple-dialog-content">',s+='<div class="simple-dialog-header"><h3 class="title">'+e.title+"</h3></div>",s+='<div class="simple-dialog-body"><p class="message">'+e.message+"</p></div>",s+='<div class="simple-dialog-footer clearfix"><a class="simple-dialog-button accept" data-action="close">'+e.acceptBtnLabel+'</a><a class="simple-dialog-button cancel" data-action="close">'+e.cancelBtnLabel+"</a></div>",s+="</div>",l.html(s),a(document).on("click",'a[data-action="close"]',function(s){s.preventDefault(),a(this).parents(".simple-dialog").removeClass("active"),a(this).hasClass("accept")&&e.success(),a(this).hasClass("cancel")&&e.cancel()})}),this},a.fn.simplePrompt=function(e){void 0===e&&(e={});return e=a.extend({title:"Prompt",message:"",acceptBtnLabel:"Accept",cancelBtnLabel:"Cancel",success:function(a){},cancel:function(a){}},e),this.each(function(){var s,l=a(this);l.addClass("simple-dialog active"),s='<div class="simple-dialog-content">',s+='<div class="simple-dialog-header"><h3 class="title">'+e.title+"</h3></div>",s+='<div class="simple-dialog-body"><p class="message">'+e.message+'</p><p class="answer"><input type="text" /></p></div>',s+='<div class="simple-dialog-footer clearfix"><a class="simple-dialog-button accept" data-action="close">'+e.acceptBtnLabel+'</a><a class="simple-dialog-button cancel" data-action="close">'+e.cancelBtnLabel+"</a></div>",s+="</div>",l.html(s),a(document).on("click",'a[data-action="close"]',function(s){s.preventDefault();var l=a(".answer input").val();a(this).parents(".simple-dialog").removeClass("active"),a(this).hasClass("accept")&&e.success(l),a(this).hasClass("cancel")&&e.cancel(l)})}),this}}(jQuery);

var params = new URLSearchParams(window.location.search);

function escape_html(value) {
  return $("<div>").text(value).html();
}

function redirect_to(path) {
  switch (path) {
    case "login_with_return_url":
      path = "/account/login?return_url=" + window.location.pathname;
      break;
  }

  window.location.href = path;
}

let watcher_formats = {
  text_success: function (value) {
    return '<span class="text-success"> ' + value + '</span>';
  },
  text_danger: function (value) {
    return '<span class="text-danger"> ' + value + '</span>';
  },
  id: function (value) {
    if (value || value === 0) {
      return "#" + value;
    }
    return "";
  },
  scenario_outcome: function (value) {
    if (value == "WON") {
      return watcher_formats.text_success(value);
    }
    else {
      return watcher_formats.text_danger(value);
    }
  },
  default_0: function (value) {
    return value || 0;
  }
};

function format_text($element, value) {
  if (value === undefined) {
    value = $element.text().trim();
  }

  let formatters = ($element.data("formatter") || "").split("|");

  formatters.forEach(formatter => {
    if (formatter && watcher_formats[formatter]) {
      value = watcher_formats[formatter](value);
    }
  })

  $element.html(value);
}

function sync_input_watcher(input) {
  let context = input.parents(".context, body").first();
  let input_name = input.attr("name");
  let watchers = $.merge(
    context.find(".input-watcher[data-input-name='" + input_name + "']"),
    $(".global-context.input-watcher[data-input-name='" + input_name + "']")
  ).filter(function (_index, element) {
    let input_selector = $(element).data("input-selector");
    if (input_selector && !input.is(input_selector)) {
      return false;
    }
    return true;
  });
  let note_watchers = context.find(".input-note-watcher[data-input-name='" + input_name + "']");
  let hideable_if_blank = context.find("[data-hide-if-blank='" + input_name + "']");

  if (input.attr("type") == "file") {
    let files = input[0].files;
    let text_element = input.closest(".custom-uploader").find(".custom-uploader-text");
    if (files.length) {
      text_element.text("" + files.length + " file(s) selected");
    }
    else {
      text_element.text(input.attr("placeholder") || "Browse...");
    }
    watchers.html(
      $.map(files, function (file) {
        return '<img src="' + URL.createObjectURL(file) + '" class="image-preview">';
      }).join("")
    );
  }
  else {
    watchers.each(function (_index, element) {
      let value = escape_html(input.val());

      if ($(element).is("[data-watch-completed-count]")) {
        value = $("[name='" + input_name + "']")
          .map((_index, element) => $(element).val() ? 1 : 0).get()
          .reduce((a, b) => a + b, 0);
      }

      format_text($(element), value);
    })
    if (!input.val() || (input.attr("type") == "number" && input.val() == 0)) {
      hideable_if_blank.hide();
    }
    else {
      hideable_if_blank.show();
    }
  }

  let total_watcher_name = input.data("add-to-sum");
  if (total_watcher_name) {
    if (input.hasClass("global-context")) {
      let inputs = $(".context").map((_index, context) => $(context).find("[data-add-to-sum='" + total_watcher_name + "']").first());
      inputs.each((_index, input) => sync_input_watcher(input));
    }
    else {
      let total_watcher = $.merge(
        context.find("[name='" + total_watcher_name + "']"),
        $(".global-context[name='" + total_watcher_name + "']")
      );
      let overrider = $.merge(
        context.find("[data-override-sum='" + total_watcher_name + "']"),
        $(".global-context[data-override-sum='" + total_watcher_name + "']")
      ).first();
      let total = 0;
      if (overrider.length) {
        total = parseInt(overrider.data("override-sum-value"));
      }
      else {
        let inputs = $("[data-add-to-sum='" + total_watcher_name + "']");
        if (!total_watcher.hasClass("global-context")) {
          inputs = $.merge(
            context.find("[data-add-to-sum='" + total_watcher_name + "']"),
            $(".global-context[data-add-to-sum='" + total_watcher_name + "']")
          );
        }
        inputs.each(function (_index, input) {
          total += parseInt($(input).val()) || 0;
        })
      }
      total_watcher.val(total).trigger("change");
    }
  }

  let extra_data = input.data("extra") || {};
  if (extra_data.note) {
    note_watchers.prevAll(".input-note-presence").text("*");
    note_watchers.text("* " + extra_data.note);
  }
  else {
    note_watchers.prevAll(".input-note-presence").text("");
    note_watchers.text("");
  }
}

function scroll_to(element) {
  $([document.documentElement, document.body]).animate({
    scrollTop: element.offset().top
  }, 200);
}

function scroll_to_invalid_input(form) {
  let first_invalid_input = form.find(".invalid:visible").first();
  if (first_invalid_input.length) {
    let summary_item = first_invalid_input.closest(".summary-item");

    scroll_to(summary_item);
  }
}

let validators = {
  validate_form: function (form) {
    let result = true;
    let inputs = form.find("input, select, textarea");

    inputs.each(function (_index, input) {
      $(input).removeClass("invalid");
      $(input).siblings(".form-control").removeClass("invalid");
      if (!input.checkValidity()) {
        $(input).addClass("invalid");
        $(input).siblings(".form-control").addClass("invalid");
        result = false;
      }
    })

    return result;
  },
  validate_campaign_form: function (form) {
    let result = validators.validate_form(form);

    let player_names = form.find("[name='campaign[players][][name]']");
    let player_heroes = form.find("[name='campaign[players][][hero]']");
    let players_count;

    for (players_count = player_names.length; players_count > 1 && !$(player_names[players_count - 1]).val() && !$(player_heroes[players_count - 1]).val(); players_count--);
    for (i = 2; i <= players_count; i++) {
      let inputs = $.merge($(player_names[i - 1]), $(player_heroes[i - 1]));

      inputs.each(function (_index, element) {
        let input = $(element);

        if (!input.val()) {
          result = false;
          input.addClass("invalid");
          input.siblings(".form-control").addClass("invalid");
        }
      })
    }

    let sessions = form.find(".session");

    sessions.each(function (_index, element) {
      let session = $(element);
      let inputs = session.find("input, select, textarea");

      let starting_salves = inputs.filter("[name='campaign[sessions][][starting_salves]']");
      let remaining_salves = inputs.filter("[name='campaign[sessions][][remaining_salves]']");

      // if (remaining_salves.val() > starting_salves.val()) {
      //   result = false;
      //   remaining_salves.addClass("invalid");
      //   remaining_salves.siblings(".form-control").addClass("invalid");
      // }
    })

    let first_invalid_session = sessions.find(".invalid").first().closest(".session");
    if (first_invalid_session.length) {
      let session_select = $("#session_select");
      let session_name = first_invalid_session.data("session-name");

      session_select[0].subselect.set_value(session_name);
    }

    return result;
  },
}

function set_custom_radio_group_value(radio_group, value) {
  let input = radio_group.find("input").first();
  if (input.is(":disabled")) {
    return;
  }

  if (value === undefined) {
    value = input.val();
  }

  let radio_buttons = radio_group.find("[data-value]");
  let active_radio_buttons = radio_buttons.filter("[data-value='" + value + "']");
  let active_class = radio_group.data("active-class") || "";
  let inactive_class = radio_group.data("inactive-class") || "";

  input.val(value).trigger("change");

  radio_buttons.not(active_radio_buttons).removeClass(active_class).addClass(inactive_class);
  active_radio_buttons.removeClass(inactive_class).addClass(active_class);
}

function initialize_custom_radio_groups(context) {
  let custom_radio_groups = context.find(".custom-radio-group");

  custom_radio_groups.each(function (_index, element) {
    set_custom_radio_group_value($(element));
  })

  custom_radio_groups.find("[data-value]").click(function () {
    let radio_group = $(this).closest(".custom-radio-group");
    let value = $(this).data("value");

    set_custom_radio_group_value(radio_group, value);
  })
}

function initialize_campaign_view(context) {
  let campaign_view = context.find("#campaign_view").first();
  let campaign_id = params.get("id");

  if (!campaign_view.length || !campaign_id) {
    return;
  }

  $.get(
    `https://dicethrone-replacements.herokuapp.com/v1/campaigns/${campaign_id}`
  ).success(function (campaign_data) {
    html = campaign_view.html()
      .replaceAll("{edit_button}", (campaign_data.email == $("#customer_email").val() ? `<a href='https://shop.dicethrone.com/pages/campaign-scores/${campaign_data.id}' class='btn btn-small'>EDIT</a>` : ""))
      .replaceAll("{url}", `/pages/leaderboard?id=${campaign_data.rank}`)
      .replaceAll("{rank}", campaign_data.rank)
      .replaceAll("{team_name}", campaign_data.team_name)
      .replaceAll("{players_count}", campaign_data.players_count)
      .replaceAll("{difficulty_level}", campaign_data.difficulty_level)
      .replaceAll("{sessions}", campaign_data.sessions.length)
      .replaceAll("{scenario_score}", campaign_data.scenario_score)
      .replaceAll("{total_score}", campaign_data.total_score);

    campaign_view.html(html);

    let session_overview = context.find(".session-overview");
    let table_body = session_overview.parent("tbody");
    let clean_session_overview_html = session_overview[0].outerHTML;

    session_overview.remove();

    campaign_data.sessions.forEach(function (session_data, i) {
      let session_overview_html = clean_session_overview_html
        .replaceAll("{session_number}", i + 1)
        .replaceAll("{explored_all_tiles}", session_data.explored_all_tiles)
        .replaceAll("{remaining_salves}", session_data.remaining_salves)
        .replaceAll("{scenario_number}", session_data.scenario_number)
        .replaceAll("{scenario_outcome}", session_data.scenario_outcome)
        .replaceAll("{starting_salves}", session_data.starting_salves)
        .replaceAll("{total_session_score}", session_data.total_score)
        .replaceAll("{unclaimed_boss_loot}", session_data.unclaimed_boss_loot)
        .replaceAll("{unspent_gold}", session_data.unspent_gold);

      table_body.append($(session_overview_html));
    })

    campaign_view.find("[data-formatter]").each((_index, element) => format_text($(element)));

    campaign_view.show();
  })
}

function initialize_leaderboard(context) {
  let leaderboard = context.find("#leaderboard").first();

  if (!leaderboard.length || params.get("id")) {
    return;
  }

  leaderboard.parent("#leaderboard_view").show();

  let clean_campaign = leaderboard.find(".leaderboard-campaign").first();

  let leaderboard_sort_input = context.find("#leaderboard_sort").find("input");

  let sort_by = params.get("filters[sort]") || leaderboard_sort_input.val();

  leaderboard_sort_input.val(sort_by);

  leaderboard_sort_input.change(function () {
    let query_params = new URLSearchParams(window.location.search);

    query_params.delete("filters[sort]");
    query_params.append("filters[sort]", $(this).val());
    redirect_to("?" + query_params.toString());
  })

  $.get(
    "https://dicethrone-replacements.herokuapp.com/v1/campaigns",
    {
      page: params.get("page"),
      filters: {
        sort: sort_by,
      },
    },
  ).success(function (data) {
    let prev_page = context.find(".prev-page");
    let next_page = context.find(".next-page");
    let query_params = new URLSearchParams(window.location.search);

    if (data.prev_page) {
      query_params.delete("page");
      query_params.append("page", data.prev_page);
      prev_page.attr("href", "?" + query_params.toString());
      prev_page.removeClass("disabled");
    }
    else {
      prev_page.addClass("disabled");
    }

    if (data.next_page) {
      query_params.delete("page");
      query_params.append("page", data.next_page);
      next_page.attr("href", "?" + query_params.toString());
      next_page.removeClass("disabled");
    }
    else {
      next_page.addClass("disabled");
    }

    data.campaigns.forEach(function (campaign_data) {
      let new_campaign = clean_campaign[0].outerHTML;

      new_campaign = new_campaign
        .replaceAll("{url}", `/pages/leaderboard?id=${campaign_data.id}`)
        .replaceAll("{rank}", campaign_data.rank)
        .replaceAll("{team_name}", campaign_data.team_name)
        .replaceAll("{players_count}", campaign_data.players_count)
        .replaceAll("{difficulty_level}", campaign_data.difficulty_level)
        .replaceAll("{sessions}", campaign_data.sessions.length)
        .replaceAll("{total_score}", campaign_data.total_score);

      new_campaign = $(new_campaign);
      if (campaign_data.email == customer.email) {
        new_campaign.find("td > div:not(.table-label)").addClass("text-success");
      }
      new_campaign.show();

      clean_campaign.parent().append(new_campaign);
    })
  })
}

function initialize(context) {
  context = context || $("body");

  initialize_campaign_view(context);

  initialize_leaderboard(context);

  context.find("[required][placeholder]").each(function (_index, input) {
    $(input).attr("placeholder", $(input).attr("placeholder") + " *");
  })

  context.find("[data-watchable]").change(function () {
    sync_input_watcher($(this));
  })

  $("[data-watchable]").each(function (_index, input) {
    sync_input_watcher($(input));
  })

  context.find("input, select, textarea").change(function () {
    let form = $(this).closest("form");
    let validator = validators[form.data("validator")];

    if ($(this).hasClass("invalid") && validator) {
      validator(form);
    }
  })

  context.find("[data-show-element='#campaign_view']").click(function (e) {
    let form = $("form");
    let validator = validators[form.data("validator")];

    if (!validator(form)) {
      e.stopImmediatePropagation();
      scroll_to_invalid_input(form);
    }
  })

  context.find("[data-show-element]").click(function () {
    $($(this).data("show-element")).show();
  })

  context.find("[data-hide-closest]").click(function () {
    $(this).closest($(this).data("hide-closest")).hide();
  })

  context.find("[data-reload]").click(function () {
    window.location.reload();
  })

  context.find("[data-show-hide]").click(function () {
    let context = $(this).parents(".context, body").first();
    let target = context.find($(this).data("show-hide"));

    if (target.is(":visible")) {
      target.hide();
      $(this).text("SHOW");
    }
    else {
      target.show();
      $(this).text("HIDE");
    }
  })

  initialize_custom_radio_groups(context);

  context.find("[name='campaign[sessions][][scenario_outcome]']").change(function () {
    let input_name = null;
    let value = null;

    let score_details = context.find(".score-details");

    if ($(this).val() == "LOST") {
      input_name = "campaign[sessions][][total_score]";
      value = -10;
      score_details.hide();
    }
    else {
      score_details.show();
    }

    $(this).attr("data-override-sum", input_name)
      .attr("data-override-sum-value", value);

    let total_watcher_name = "campaign[sessions][][total_score]";
    let inputs = $(".context").map((_index, context) => $(context).find("[data-add-to-sum='" + total_watcher_name + "']").first());
    inputs.each((_index, input) => sync_input_watcher(input));

    let current_session = $(this).closest(".session");
    let remaining_salves = current_session.find("[name='campaign[sessions][][remaining_salves]']");

    remaining_salves.trigger("change");
  })

  context.find("[name='campaign[sessions][][starting_salves]']").change(function () {
    let current_session = $(this).closest(".session");
    let prev_session = current_session.prev(".session");
    if (!prev_session.length) {
      return;
    }

    let prev_won = prev_session.find("[name='campaign[sessions][][scenario_outcome]']").val() == "WON";
    let difference = prev_won ? 0 : 3;
    let prev_remaining_salves = prev_session.find("[name='campaign[sessions][][remaining_salves]']");
    let new_value = parseInt($(this).val() || "0") - difference;

    if (prev_remaining_salves.val() != new_value) {
      prev_remaining_salves.val(new_value).trigger("change");
    }
  })

  context.find("[name='campaign[sessions][][remaining_salves]']").change(function () {
    let current_session = $(this).closest(".session");
    let next_session = current_session.next(".session");
    if (!next_session.length) {
      return;
    }

    let won = current_session.find("[name='campaign[sessions][][scenario_outcome]']").val() == "WON";
    let difference = won ? 0 : 3;
    let next_starting_salves = next_session.find("[name='campaign[sessions][][starting_salves]']");
    let new_value = parseInt($(this).val() || "0") + difference;

    if (next_starting_salves.val() != new_value) {
      next_starting_salves.val(new_value).trigger("change");
    }
  })

  context.find("[name='campaign[sessions][][scenario_number]']").change(function () {
    let current_session = $(this).closest(".session");
    let scenario_number = $(this).val();
    let unclaimed_boss_loot = current_session.find("[name='campaign[sessions][][unclaimed_boss_loot]']");
    let explored_all_tiles = current_session.find("[name='campaign[sessions][][explored_all_tiles]']");

    if (["2", "4", "6", "8", "10", "12"].includes(scenario_number)) {
      set_custom_radio_group_value(explored_all_tiles.closest(".custom-radio-group"), "");

      unclaimed_boss_loot.attr("disabled", false);
      explored_all_tiles.attr("disabled", true);
    } else if (["1", "3", "5", "7", "9", "11", "13", "15"].includes(scenario_number)) {
      unclaimed_boss_loot.closest(".special-input")[0].special_input.set_value("0");

      unclaimed_boss_loot.attr("disabled", true);
      explored_all_tiles.attr("disabled", false);
    }
    else {
      unclaimed_boss_loot.attr("disabled", false);
      explored_all_tiles.attr("disabled", false);
    }
  })
}

function initialize_session_overview(session_overview, session_number) {
  if (!session_overview.length || params.get("id")) {
    return;
  }

  session_number = session_number || 1;

  let html = session_overview.html();

  html = html.replaceAll("{session_number}", session_number);
  session_overview.html(html);
}

$(document).ready(function () {
  let customer_email_input = $("[name='campaign[email]'][required]").first();

  if (customer_email_input.length && !customer_email_input.val()) {
    redirect_to("login_with_return_url");
  }

  let clean_session = $(".session").first().clone();

  let session_overview = $(".session-overview").first();
  let clean_session_overview = session_overview.clone();

  let session_select = $("#session_select");

  initialize_session_overview(session_overview);

  initialize();

  function add_new_session() {
    let new_session = clean_session.clone();
    let subselect_object = session_select[0].subselect;
    let session_number = Object.keys(subselect_object.get_options()).length + 1
    let session_name = "SESSION " + session_number;

    let new_session_overview = clean_session_overview.clone();
    initialize_session_overview(new_session_overview, session_number);
    new_session_overview.appendTo($(".session-overview").parent("tbody"));

    new_session.attr("data-session-name", session_name);

    new_session.appendTo($(".sessions-list"));
    initialize(new_session);
    initialize_special_inputs(new_session);

    subselect_object.add_options({
      [session_name]: {},
    });

    subselect_object.set_value(session_name);

    let prev_session = new_session.prev(".session");
    let prev_remaining_salves = prev_session.find("[name='campaign[sessions][][remaining_salves]']");

    prev_remaining_salves.trigger("change");
  }

  $(".new-session").click(add_new_session)

  session_select.find("input").change(function () {
    let sessions = $(".session");
    sessions.hide();
    sessions.filter("[data-session-name='" + $(this).val() + "']").show();
  })

  $("form").submit(function () {
    $("[data-disable-with]").each(function (_index, button) {
      $(button).attr("disabled", true);
      $(button).text($(button).data("disable-with"));
    })
  })

  $("form[data-ajax]").submit(function (event) {
    event.preventDefault();

    let form = $(this);

    $.ajax({
      type: "POST",
      enctype: "multipart/form-data",
      url: form.attr("action"),
      data: new FormData(this),
      processData: false,
      contentType: false,
      cache: false,
      success: function () {
        if (form.is("[data-go-to-last-step]")) {
          go_to_step($(".steps > .step:last-of-type"));
        }

        if (form.is("[data-redirect-to-leaderboard]")) {
          redirect_to("/pages/leaderboard");
        }
      }
    });
  })

  initialize_special_inputs();

  function set_value(input, value) {
    const special_input = input.closest(".special-input, .subselect")[0]?.special_input

    if (special_input) {
      special_input.set_value(value)
      return
    }

    const custom_radio_group = input.closest(".custom-radio-group")

    if (custom_radio_group.length) {
      set_custom_radio_group_value(custom_radio_group, value)
      return
    }

    input.val(value)
  }

  const url = window.location.pathname;
  const campaign_id = url.substring(url.lastIndexOf('/') + 1);

  if(parseInt(campaign_id) == campaign_id){
    $.get(
      'https://dicethrone-replacements.herokuapp.com/v1/campaigns/'+campaign_id+'/unfiltered_show'
      ).success(function (campaign_data) {
      if(campaign_data.email == customer.email){
        const campaign_fields = ["id", "team_name", "difficulty_level", "scenario_score"]
        campaign_fields.forEach(field => { set_value($(`[name='campaign[${field}]']`), campaign_data[field]) })

        campaign_data.players.forEach((player_data, i) => {
          set_value($($("[name='campaign[players][][hero]']")[i]), player_data.hero)
          set_value($($("[name='campaign[players][][name]']")[i]), player_data.name)
        })

        Array.from({ length: campaign_data.sessions.length - 1 }).forEach(() => add_new_session())

        campaign_data.sessions.forEach((session_data, i) => {
          const session = $($(".sessions-list > .session")[i])
          const session_fields = ["scenario_outcome", "scenario_number", "starting_salves", "remaining_salves", "unspent_gold", "unclaimed_boss_loot", "explored_all_tiles"]
          session_fields.forEach(field => { set_value(session.find(`[name='campaign[sessions][][${field}]']`), session_data[field]) })
        })
      }
    })

  }
})

$(document).on("click", '[data-value="Marvel"]', function () {
  $('#shopify-error-popup').simpleAlert({
    message: "All parts requests for the retail versions of Marvel Dice Throne need to be submitted to <a style='color:black; text-decoration: underline;' target='_blank' href='https://theop.games/pages/replacements'>https://theop.games/pages/replacements.</a> Retail versions are the 4-hero box and the two 2-hero boxes. Dice Throne, Inc. can only provide parts for the Marvel Dice Throne Battle Chests.",
    title: ""
  });
})

$(document).on("click", '[data-value="Normal"]', function () {
  let cont = $("body").find("[name='campaign[scenario_score]']")
  // cont.attr("disabled", false);
  cont.closest(".special-input")[0].special_input.set_value("20");
  // cont.attr("disabled", true);
})

$(document).on("click", '[data-value="Veteran"]', function () {
  let cont = $("body").find("[name='campaign[scenario_score]']")
  // cont.attr("disabled", false);
  cont.closest(".special-input")[0].special_input.set_value("30");
  // cont.attr("disabled", true);
})

$(document).on("click", '[data-value="Other"]', function () {
  let cont = $("body").find("[name='campaign[scenario_score]']")
  // cont.attr("disabled", false);
  cont.closest(".special-input")[0].special_input.set_value("");
})
